import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"overflow":"hidden"} }
const _hoisted_2 = { style: {"width":"890px","float":"left"} }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { style: {"width":"300px","float":"right"} }
const _hoisted_8 = { style: {"display":"inline-block","width":"60px"} }
const _hoisted_9 = { class: "next_btn" }

import { useRouter,useRoute } from "vue-router"
import { reactive, ref, toRefs } from "vue"
import { AREA_ID } from "@/config/const"
import { queryItemByServiceCode,queryByOneThingIdAndAreaCode, preServiceMaterialList } from "@/config/request"
import { useStore } from "vuex"
import { ElMessage } from "element-plus"
import { getOneThingItemList } from "@/config/request"


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const store = useStore()
const query = route.query
const data = reactive({
    query: {},
    itemList: [],
    oneThingDetail: [],
    matterList: [],
}) as any

const getQueryData = async() => {
    data.query = route.query
    let params = {
        serviceCode:data.query.selectServiceCode
    }
    let res = await queryItemByServiceCode(params) as any
    if(res.code === 200){
        data.itemList = res.result.records
    }
}
const getOneThingDetail = async() => {
    let params = {
        oneThingId: data.query.unid,
        areaCode: AREA_ID,
    }
    let res = await queryByOneThingIdAndAreaCode(params) as any
    if(res.code === 200){
        data.oneThingDetail = res.result.result
    }
}
let dialogVisible = ref(false)
const showMatter = async() => {
    dialogVisible.value = true
    let matterParams = {
        code: data.query.selectServiceCode,
        modelCode: data.query.modelCode,
    }
    let matterResult = await preServiceMaterialList(matterParams) as any
    if(matterResult.code === 200){
        data.matterList = matterResult.result
    }
}

const userInfo = store.state.userInfomation

const nextOne = async() => {
    let dataUser = userInfo;
    if(!dataUser?.userType){
        ElMessage.warning("请先登录")
        return false;
    }
    let dict = {"自然人":1,"法人":2} as any
    let userType = [] as any;
    let param = {
        modelCode: data.query.modelCode,
        isbig: '1',
        theme: data.query.theme
    }
    let res = await getOneThingItemList(param) as any

    if(res.code == 200){
        let itemList = res.result.records[0] || [];
        let itemtype = itemList.userType
        itemtype.split(",").forEach((type:string)=>{
            userType.push(Number.parseInt(dict[type]))
        })
        if(userType.includes(Number.parseInt(dataUser.userType))){
        //if(2 > 1){
            let param = {
                proviceId:dataUser.cuserId,// 省用户id
                usertype:dataUser.userType,// 用户类型 1个人 2法人
                userName:dataUser.userName,// 用户姓名
                usermobile:dataUser.userMobile,// 手机号码
                userpid:dataUser.certNo, // 身份证号码
                incname:dataUser.corpName, // 企业名称
                inczzjgdm:dataUser.certificateSno,// 组织机构代码
            }
            localStorage.setItem('govUserInformation',JSON.stringify(param));
        }else{
            ElMessage.warning("当前登录用户的类型与事项的用户类型不一致，无法进行下一步办理！")
            return false;
        }
    }
    let params = {
        parentid: data.query.parentid,
        modelCode: data.query.modelCode,
        modelName: data.query.modelName,
        selectServiceCode: data.query.selectServiceCode,
        guideId: data.query.guideId,
        projectcode: data.query.projectcode

    }

    toPath('./notic', params)
}

const toPath = (path: string, params: any) => {
    router.push({
        path: path,
        query: params
    })
}

const init = () => {
    getQueryData()
    getOneThingDetail()
}
init()


return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "t6_breadCream" }, [
        _createElementVNode("span", null, "首页"),
        _createTextVNode(),
        _createElementVNode("i", null, ">"),
        _createTextVNode(),
        _createElementVNode("span", null, "一件事"),
        _createTextVNode(),
        _createElementVNode("i", null, ">"),
        _createTextVNode(),
        _createElementVNode("span", null, "办事指南")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "title" }, "基本信息", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_descriptions, {
                title: "",
                border: "true",
                column: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "一件事名称" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.modelName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "主办单位" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.hostDept), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "牵头单位" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.leadDept), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "事项类型" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.onetingType), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "办件类型" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.handlingType), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "递交材料" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.xdjcl) + " 份", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "title" }, "联办信息", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_table, {
                data: data.itemList,
                stripe: "",
                border: "",
                "max-height": "200px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "serviceName",
                    label: "事项名称"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "deptName",
                    label: "部门名称",
                    width: "220"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "infoType_dictText",
                    label: "办件类型",
                    width: "150"
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "title" }, "申请条件", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: data.oneThingDetail.handlingConditions
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "title" }, "受理方式", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: data.oneThingDetail.acceptType
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("div", { class: "title" }, "办理流程", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(data.oneThingDetail.flowDesc), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", { class: "title" }, "收费/中介信息", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_descriptions, {
                title: "",
                column: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "是否收费:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.ischarge), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "收费依据:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.chargeBasis), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "中介名称:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.intermediaryName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "实施依据:" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.intermediaryLegalStandard), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createElementVNode("div", { class: "title" }, "办理结果", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: data.oneThingDetail.flowResult
            }, null, 8, _hoisted_5)
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("div", { class: "title" }, "责任义务", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: data.oneThingDetail.obligations
            }, null, 8, _hoisted_6)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createElementVNode("div", { class: "title" }, "分开办", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_descriptions, {
                title: "",
                border: "true",
                column: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "办理时间" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.yblsj) + "工作日", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "跑动次数" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.yptcs) + " 次", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "递交材料" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.ydjcl) + " 份", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createElementVNode("div", { class: "title" }, "一次办", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_descriptions, {
                title: "",
                border: "true",
                column: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "办理时间" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.xblsj) + "工作日", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "跑动次数" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.xptcs) + " 次", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "递交材料" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(data.oneThingDetail.xdjcl) + " 份", 1),
                      _createElementVNode("span", null, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "success",
                          onClick: showMatter
                        }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createTextVNode("查看", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createElementVNode("div", { class: "title" }, "窗口电话", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_descriptions, {
                title: "",
                border: "true",
                column: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "咨询电话" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.consultationTelephone), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "投诉电话" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.oneThingDetail.complaintMode), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createElementVNode("div", { class: "title" }, "窗口办公时间", -1)
          ]))]),
          default: _withCtx(() => [
            _cache[14] || (_cache[14] = _createElementVNode("div", null, [
              _createElementVNode("p", null, "周一至周五，法定节假日除外。"),
              _createElementVNode("p", null, "夏季：上午09:00-12:00； "),
              _createElementVNode("p", { style: {"padding-left":"42px"} }, "下午13:00-17:00；"),
              _createElementVNode("p", null, "冬季：上午09:00-12:00； "),
              _createElementVNode("p", { style: {"padding-left":"42px"} }, "下午13:00-17:00；")
            ], -1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[15] || (_cache[15] = [
            _createElementVNode("div", { class: "title" }, "窗口地址", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(data.oneThingDetail.windowInfo), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "box-card" }, {
          header: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createElementVNode("div", { class: "title" }, "结果送达", -1)
          ]))]),
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(data.oneThingDetail.resultSend), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_button, {
        onClick: nextOne,
        size: "large",
        color: "#4ACAB6",
        style: {"color":"#fff"}
      }, {
        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
          _createTextVNode("跳转注意事项", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : dialogVisible = $event)),
        title: "材料列表",
        width: "800"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: data.matterList,
            stripe: "",
            border: "",
            "max-height": "500px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "index",
                width: "60",
                label: "序号",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "materialAlias",
                label: "材料名称"
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})